export default __webpack_public_path__ + "static/G_Pay_Lockup_1_.png";